<template lang="pug">
v-main
    v-container(fluid)
        v-card
            ModalSearch(:openDialog="openDialog" @closeModal="openDialog = false")
            v-toolbar.elevation-0(color="white")
                v-row
                    v-col(md="10")
                        v-toolbar-title {{ title }}
                    v-col(md="2")
                        v-btn(color="blue darken-1"  style="color:#ffffff;float:right" @click="openModal") Search ADMIN FROM ANOTHER BU
            v-divider
            div.pb-6
                v-card(elevation="0" class="card-contact-first")
                    div(class="d-flex")
                        div(class="flex-column contact-padding")
                            div.title-contact We'd be more than happy to talk to you.
                            div.subtitle-contact Here's how to contact us.
                        div(class="ml-auto")
                            img(src="../assets/whatsapp-contact.png" class="img-contact")

                v-card(elevation="0" class="card-contact" v-for="data in users")
                    div.title-contact {{ data.business_unit.bu_name }}
                    div(class="subtitle-contact pb-1") Contact us via the link below
                    
                    div(class="mt-6" v-for="admin in data.admin")
                        v-btn(
                            rounded
                            color="primary"
                            dark
                            :href="`https://mail.google.com/mail/?view=cm&fs=1&to=${admin.email}&su=${subject}&body=${bodyEmail}`"
                            target="_blank"
                            class="elevation-0 pa-4 mr-3 text-lowercase"
                        ) 
                            v-icon.mr-2 email 
                            | {{ admin.email }}

                        v-btn(
                            rounded
                            color="green"
                            dark
                            class="elevation-0 pa-4"
                            :href="`https://wa.me/${admin.msisdn}?text=${bodyWhatsApp}`"
                            target='_blank'
                            v-if="admin.msisdn"
                        ) 
                            img(src="../assets/ic_whatsapp.svg" class="mr-2")
                            | {{ admin.msisdn }}

    v-overlay(:value="overlay")
        v-progress-circular(indeterminate, size="64")

</template>

<script>
import axios from "axios";
import ModalSearch from "./ModalSearch.vue"
export default {
    name: "Contact",
    components: {ModalSearch},
    props: {
        title: ''
    },
    data() {
        return {
           subject: "Question Memo",
           bodyEmail: "Hi Admin,%0D%0A%0D%0AI need your help for iMemo TechConnect%0D%0A%0D%0AThanks",
           bodyWhatsApp: "Hi Admin,%0A%0AI need your help for iMemo TechConnect",
           users: [],
           overlay: false,
           openDialog:false
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.overlay = true
            let token = localStorage.getItem("token");
            axios
            .get(process.env.VUE_APP_API + `/business-unit/admin-contact`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                this.overlay = false
                this.users = res.data.data;
            })
            .catch((err) => {
                this.overlay = false
                this.$toaster.error(err.response.error, { icon: "error" });
            })
            .finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        openModal(){
            this.openDialog = true
        }
    }
}
</script>

<style>
    .v-toolbar__content {
        box-shadow: none;
    }

    .contact-padding{
        padding: 2rem;
    }

    .card-contact-first{
        margin: 1.5rem;
        background: #F7F7F7 !important;
    }

    .card-contact{
        background: #F7F7F7 !important;
        padding: 2rem;
        margin: 1.5rem;
    }

    .title-contact{
        font-size: 24px;
        color: #121212;
        font-weight: 500;
    }

    .subtitle-contact{
        font-size: 16px;
        color: #555555;
        margin-top: 0.4rem;
    }

    .img-contact{
        height: 160px;
        width: auto
    }
</style>